import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListViewComponent } from 'src/app/_shared/component/list copy/list-view/list-view.component';
import { RedirectionGuard } from '../_shared/guard/redirection.guard';
import { MapViewComponent } from './component/map/map-view/map-view.component';
import { WorkspaceComponent } from './component/workspace/workspace.component';

const routes: Routes = [
  {
    path: '',
    component: WorkspaceComponent,
    children: [
      {
        path: '',
        redirectTo: 'map',
      },
      {
        path: 'map/:state/:city/:street/:unit?/:subtype/:propertyId',
        component: MapViewComponent,
      },
      {
        path: 'map',
        component: MapViewComponent,
      },
      {
        path: 'list',
        component: ListViewComponent,
      },
    ],
    canActivate: [RedirectionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkspaceRoutingModule { }
